import * as React from 'react';

import { PK } from 'common/types';
import { useMinisList } from 'modules/minis/queries';
import { translate as t } from 'common/utils/translate';

import StaticPicker from './StaticPicker';

interface PickerProps {
  pk?: PK;
  collectionItems?: PK[];
}

const MinisPicker = ({ pk, collectionItems }: PickerProps) => {
  const { data: minisListData } = useMinisList();
  const minisList = minisListData?.values;

  return (
    <StaticPicker
      pk={pk}
      divider={false}
      sectionTitle={t("Add mini's")}
      contentList={minisList ?? []}
      collectionItems={collectionItems ?? []}
      forceOpen
    />
  );
};

export default MinisPicker;
